import { render, staticRenderFns } from "./ToggleSwitch.vue?vue&type=template&id=48356650&scoped=true"
import script from "./ToggleSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./ToggleSwitch.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ToggleSwitch.vue?vue&type=style&index=0&id=48356650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48356650",
  null
  
)

export default component.exports